import React, {createContext, useReducer} from 'react';
import PayrollImportReducer from './reducer';

const PayrollImportStore = createContext({});

const PayrollImportProvider = ({children}) => {
    const usePayrollImportState = useReducer(
        PayrollImportReducer,
        {
            sortedBy: undefined,
            filter: {},
            bulkEdit: false,
            options: {
                permissionLevel: [],
                skills: [],
                employmentStatus: []
            },
            rawData: [],
            data: [],
            validation: {},
            hasAssociatesData: false,
        }
    );

    return (
        <PayrollImportStore.Provider value={usePayrollImportState}>
            {children}
        </PayrollImportStore.Provider>
    )
};

export {PayrollImportProvider};
export default PayrollImportStore;